
namespace Matrix.Indexation {
    export class DimBasketConstituentColumns {
        static columnsKey = 'Indexation.DimBasketConstituent';
    }
}